import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, FormControl, InputLabel, Select,
} from '@mui/material';
import { useStyles } from './styles';
import Loader from '../../../commons/Loader';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function HeightSection({
  loader,
  heights,
  inputData,
  setInputDataToSend,
}) {
  const classes = useStyles();

  const handleHeightSelectChange = ({ target }) => {
    setInputDataToSend('height', target.value);
    setInputDataToSend('panelDescription', '');
  };

  return (
    <Box className={classes.inputWrapper}>
      <FormControl variant="standard" className={classes.form}>
        <InputLabel id="width-label">Height</InputLabel>
        <Select
          disabled={loader.height}
          native
          onChange={handleHeightSelectChange}
          color="secondary"
          labelId="height-label"
          variant="standard"
          value={inputData.height || ''}
        >
          <option value="" aria-label="None" />
          {heights.uniqueAttributesValues?.map((height) => (
            <option value={height} key={height}>{height}</option>
          ))}
        </Select>
      </FormControl>
      <Loader target="height" offsetRight={48} size={18} centeredY />
    </Box>
  );
}

HeightSection.propTypes = {
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  heights: PropTypes.shape({
    uniqueAttributesValues: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
};
